// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3AOmN","buttons":"RemoveExpirationActionButtons_buttons__3512r"};